













import { Component, Prop, Vue } from 'vue-property-decorator';
import MailButton from '@/components/Invoicing/Shared/MailButton.vue';
import gql from 'graphql-tag';

const VACATION_MONEY_SUMMARY_MAIL = gql`
  mutation emailVacationMoneySummary($unitId: ID!, $year: Int!, $recipients: [String!]!) {
    emailVacationMoneySummary(input: { unitId: $unitId, year: $year, recipients: $recipients }) {
      success
    }
  }
`;

@Component({
  components: {
    MailButton,
  },
})
export default class SummaryMailButton extends Vue {
  @Prop({ type: String, required: true }) private unitId!: string;
  @Prop({ type: Number, required: true }) private year!: number;

  private VACATION_MONEY_SUMMARY_MAIL = VACATION_MONEY_SUMMARY_MAIL;

  private get entity(): string {
    return this.$t('PaycheckReport.VacationMoneyReport.Summary.entity') as string;
  }

  // The pdf is printed and mailed by a background job, so it is not sent yet
  private onSent(): void {
    this.$sMessage.success(this.$t('PaycheckReport.VacationMoneyReport.Summary.sendQueued'));
  }
}
